export default "__VITE_ASSET__Bt3CQs0c__"